var _circle, _circle2, _mask, _path, _path2, _ellipse, _ellipse2, _g, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _ellipse3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepsNoCandidates({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    viewBox: "0 0 232 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 116,
    r: 116,
    fill: "#F4F5F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2947_135309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 232,
    height: 232
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 116,
    r: 116,
    fill: "#F4F5F6"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2947_135309)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2947_135309",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-15.382 121.213C-16.3509 119.131 -15.4486 116.657 -13.3665 115.689L150.571 39.3993C152.653 38.4304 155.126 39.3327 156.095 41.4148L201.058 138.036C202.027 140.118 201.125 142.591 199.043 143.56L35.1053 219.849C33.0233 220.818 30.55 219.916 29.5812 217.834L-15.382 121.213ZM63.089 93.4327C60.5864 94.5996 59.5037 97.5743 60.6707 100.077C61.8376 102.579 64.8123 103.662 67.3148 102.495L88.4605 92.6347C90.963 91.4678 92.0457 88.4931 90.8787 85.9906C89.7118 83.4881 86.7371 82.4054 84.2346 83.5723L63.089 93.4327Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-15.382 121.213C-16.3509 119.131 -15.4486 116.657 -13.3665 115.689L150.571 39.3993C152.653 38.4304 155.126 39.3327 156.095 41.4148L201.058 138.036C202.027 140.118 201.125 142.591 199.043 143.56L35.1053 219.849C33.0233 220.818 30.55 219.916 29.5812 217.834L-15.382 121.213ZM63.089 93.4327C60.5864 94.5996 59.5037 97.5743 60.6707 100.077C61.8376 102.579 64.8123 103.662 67.3148 102.495L88.4605 92.6347C90.963 91.4678 92.0457 88.4931 90.8787 85.9906C89.7118 83.4881 86.7371 82.4054 84.2346 83.5723L63.089 93.4327Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.3665 115.689L-13.0741 116.317L-13.3665 115.689ZM-15.382 121.213L-16.0104 121.505L-15.382 121.213ZM150.571 39.3993L150.278 38.771L150.571 39.3993ZM156.095 41.4148L155.467 41.7072L155.467 41.7072L156.095 41.4148ZM201.058 138.036L201.686 137.743L201.058 138.036ZM199.043 143.56L199.335 144.188L199.043 143.56ZM35.1053 219.849L35.3977 220.477L35.3977 220.477L35.1053 219.849ZM29.5812 217.834L28.9529 218.126L29.5812 217.834ZM63.089 93.4327L63.3818 94.0608L63.089 93.4327ZM67.3148 102.495L67.022 101.867L67.3148 102.495ZM88.4605 92.6347L88.1676 92.0067L88.4605 92.6347ZM84.2346 83.5723L84.5275 84.2004L84.2346 83.5723ZM-13.6589 115.06C-16.0879 116.191 -17.1407 119.076 -16.0104 121.505L-14.7537 120.92C-15.5611 119.185 -14.8092 117.124 -13.0741 116.317L-13.6589 115.06ZM150.278 38.771L-13.6589 115.06L-13.0741 116.317L150.863 40.0276L150.278 38.771ZM156.723 41.1224C155.593 38.6934 152.707 37.6406 150.278 38.771L150.863 40.0276C152.598 39.2202 154.659 39.9721 155.467 41.7072L156.723 41.1224ZM201.686 137.743L156.723 41.1224L155.467 41.7072L200.43 138.328L201.686 137.743ZM199.335 144.188C201.764 143.058 202.817 140.172 201.686 137.743L200.43 138.328C201.237 140.063 200.485 142.124 198.75 142.931L199.335 144.188ZM35.3977 220.477L199.335 144.188L198.75 142.931L34.8129 219.221L35.3977 220.477ZM28.9529 218.126C30.0832 220.555 32.9687 221.608 35.3977 220.477L34.8129 219.221C33.0779 220.028 31.0169 219.276 30.2095 217.541L28.9529 218.126ZM-16.0104 121.505L28.9529 218.126L30.2095 217.541L-14.7537 120.92L-16.0104 121.505ZM61.2988 99.7839C60.2936 97.6283 61.2262 95.0659 63.3818 94.0608L62.7961 92.8046C59.9467 94.1333 58.7139 97.5203 60.0426 100.37L61.2988 99.7839ZM67.022 101.867C64.8663 102.872 62.304 101.94 61.2988 99.7839L60.0426 100.37C61.3713 103.219 64.7583 104.452 67.6077 103.123L67.022 101.867ZM88.1676 92.0067L67.022 101.867L67.6077 103.123L88.7534 93.2628L88.1676 92.0067ZM90.2507 86.2835C91.2559 88.4391 90.3232 91.0015 88.1676 92.0067L88.7534 93.2628C91.6027 91.9341 92.8355 88.5471 91.5068 85.6977L90.2507 86.2835ZM84.5275 84.2004C86.6831 83.1952 89.2455 84.1278 90.2507 86.2835L91.5068 85.6977C90.1781 82.8483 86.7911 81.6156 83.9417 82.9442L84.5275 84.2004ZM63.3818 94.0608L84.5275 84.2004L83.9417 82.9442L62.7961 92.8046L63.3818 94.0608Z",
    fill: "#E8EAED",
    mask: "url(#path-3-inside-1_2947_135309)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.8192,
    cy: 154.156,
    rx: 24.9982,
    ry: 24.9982,
    transform: "rotate(-24.9552 46.8192 154.156)",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2947_135309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 129,
    width: 51,
    height: 51
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.8192,
    cy: 154.156,
    rx: 24.9982,
    ry: 24.9982,
    transform: "rotate(-24.9552 46.8192 154.156)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2947_135309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.491 159.757C54.6548 160.606 55.279 162.445 55.9551 163.102C56.2108 163.353 63.1138 162.871 63.9225 162.819C65.6336 162.717 67.2103 162.724 68.0261 163.085C68.9535 163.486 71.9517 168.736 72.6776 170.295C60.8465 175.801 54.6456 178.687 42.8146 184.192C42.0887 182.633 40.0035 176.958 40.2935 175.99C40.5428 175.134 41.5707 173.961 42.733 172.68C43.2939 172.095 48.1079 167.124 48.0804 166.767C48.0129 165.826 47.0084 164.165 46.4641 163.492C50.127 158.733 48.5116 159.439 54.491 159.757Z",
    fill: "#FFD0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8687 163.136C57.8687 163.136 57.3127 166.217 56.1105 166.916C54.2969 167.991 53.5571 167.595 51.7175 166.924C50.1744 166.392 48.264 165.569 47.4029 164.812C47.4029 164.812 46.2895 163.017 46.0338 162.765C45.74 162.532 48.7927 159.445 48.7927 159.445L52.4855 157.634L54.5111 159.7C54.5111 159.7 55.1345 162.233 55.9752 163.045L57.8687 163.136Z",
    fill: "#FFB4AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3363 160.189C42.3363 160.189 41.3544 161.063 40.1129 160.484C38.8715 159.904 35.3165 156.144 39.0616 155.142L42.3363 160.189Z",
    fill: "#FFD0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4485 154.693C54.4485 154.693 55.7491 154.505 56.1054 153.182C56.4617 151.859 55.8741 146.718 52.6955 148.937L54.4485 154.693Z",
    fill: "#FFD0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4651 159.74C52.6592 164.537 51.6523 165.005 46.7828 163.315C43.5737 162.171 42.1074 160.093 40.713 157.486C39.4447 155.151 37.1914 152.161 37.905 149.893C39.0292 146.361 46.4877 142.89 49.9132 144.304C52.1085 145.22 52.9074 148.886 53.9146 151.343C55.0107 154.088 55.6566 156.549 54.4651 159.74Z",
    fill: "#FFD9D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8645 157.962L40.7395 157.555L38.4904 153.419C38.4904 153.419 35.6459 149.096 43.8931 145.536C43.8931 145.536 49.2137 143.245 51.5016 146.669L53.6233 151.328L54.2877 151.065L53.8546 148.444C53.8546 148.444 53.2975 145.556 51.4089 143.288C48.2645 139.614 43.7089 140.068 40.0056 142.254C36.2643 144.458 34.9325 147.762 36.0233 151.697C36.5386 153.401 37.6494 155.291 39.8645 157.962Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5495 163.147C59.7092 163.113 63.3394 162.859 63.9225 162.819C65.6336 162.717 67.2103 162.724 68.0262 163.084C68.9535 163.486 71.9518 168.735 72.6776 170.295C60.8465 175.801 54.6457 178.686 42.8146 184.192C42.0888 182.632 40.0035 176.958 40.2935 175.99C40.5428 175.133 41.5707 173.961 42.7331 172.68C43.1391 172.259 45.6921 169.59 47.126 167.997C49.0303 169.703 51.7167 170.304 53.9992 169.242C56.3401 168.106 57.6279 165.702 57.5495 163.147Z",
    fill: "#568BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3899 152.684C36.3899 152.684 33.3841 147.419 35.7969 143.056C38.0142 138.97 40.206 139.801 40.4881 134.44C40.563 133.11 47.0472 140.181 49.2258 141.481C51.4778 142.84 52.1328 144.247 52.1328 144.247L43.8875 143.734L39.8072 145.309L37.159 149.364L36.3899 152.684Z",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86.4023,
    y: 139.248,
    width: 83.9041,
    height: 9.99927,
    rx: 4.99963,
    transform: "rotate(-24.9552 86.4023 139.248)",
    fill: "#E3E5E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112.304,
    y: 124.615,
    width: 54.2476,
    height: 14.6761,
    rx: 7.33805,
    transform: "rotate(-24.9552 112.304 124.615)",
    fill: "#E3E5E7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2744,
    y: 123.898,
    width: 37.0534,
    height: 9.99927,
    rx: 4.99963,
    transform: "rotate(-24.9552 80.2744 123.898)",
    fill: "#E3E5E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.248 142.094L203.623 131.747L218.395 135.137C218.791 135.228 219.039 135.623 218.948 136.02L216.903 144.931C216.812 145.327 216.417 145.575 216.02 145.484L201.248 142.094Z",
    fill: "#4688F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M241.274 136.645L237.68 153.182L213.485 147.923C213.087 147.837 212.835 147.445 212.922 147.047L216.203 131.95C216.289 131.552 216.682 131.3 217.079 131.386L241.274 136.645Z",
    fill: "#7DACF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.559 141.914L196.607 128.632L203.523 130.219C203.92 130.31 204.168 130.705 204.077 131.102L201.358 142.948C201.267 143.345 200.872 143.592 200.475 143.501L193.559 141.914Z",
    fill: "#7DACF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.586 105.67C200.682 124.483 195.267 149.511 176.505 161.573C157.743 173.636 132.726 168.174 120.63 149.361C108.535 130.548 113.949 105.52 132.711 93.4576C151.473 81.3947 176.491 86.857 188.586 105.67Z",
    stroke: "#4688F1",
    strokeWidth: 3.68359
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.18,
    cy: 126.918,
    rx: 44.904,
    ry: 44.904,
    transform: "rotate(-32.7384 152.18 126.918)",
    stroke: "#7DACF5",
    strokeWidth: 3.68359
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.18,
    cy: 126.919,
    rx: 36.2178,
    ry: 35.9441,
    transform: "rotate(-32.7384 152.18 126.919)",
    fill: "#7DACF5",
    fillOpacity: 0.07
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsNoCandidates);
export default __webpack_public_path__ + "static/media/stepsNoCandidates.755249e4451b72d51822929274613d75.svg";
export { ForwardRef as ReactComponent };